jQuery(".section-footer__row h4").click(function(){
      jQuery(this).parent(".section-footer__menu-block").toggleClass("open"); 
});

window.onload = (event) => {
  console.log('page is fully loaded');
  setTimeout( () => {
             const accordion = document.getElementsByClassName('yotpo-verified-buyer');

  for ( i=0; i < accordion.length; i++) {
    accordion[i].addEventListener('click', function () {
      this.classList.toggle('active')
    })
  }
}, 5000)
};


/* GET NUMBER OF PRODUCTS ON COLLECTION PAGE*/
// let numberOfProducts = document.querySelectorAll('div[data-section-type="collection-template"] .product-block');
// let itemsNumber = document.querySelector('#productItems');

// console.log(numberOfProducts.length)

// itemsNumber.innerText = numberOfProducts.length;


// let currentPage = parseInt(document.querySelector(".currentPage").innerText);

// let collectionItems = document.querySelectorAll(".product-block").length;

// let itemsPerPage = parseInt(document.querySelector(".itemsPerPage").innerText);
// console.log(currentPage, itemsPerPage, collectionItems)
// let multiplier = currentPage * collectionItems;
// let rangeCount = (currentPage - 1) * itemsPerPage;

// rangeCount = rangeCount === 0 ? 1 : rangeCount;

// document.getElementById("productsOfView").innerText = `${rangeCount}-${multiplier}`


// console.log(currentPage)

/*END*/

/*INTERSECTION OBSERVER FOR BG IMG LAZYLOAD ON HOMEPAGE */
const image = document.querySelector("section.two-columns.inverted");
if(window.location.pathname == '/'){
  
  const options = {
    root: null,
    threshold: 0,
    rootMargin: "150px",
  };
  
const observer = new IntersectionObserver(function (entries,observer) {
  entries.forEach(entry => {
    if (!entry.isIntersecting) {
      return;
    }
    entry.target.classList.add("lazyLoad");
  });
}, options);

observer.observe(image);
}
/* END */



/* FIX FOR OWLCAROUSEL GLITCH ON PAGE LOAD */
const announcementBar = document.querySelector('div#custom-announcement-bar');
window.addEventListener("load", event => {
   announcementBar.classList.add("js_opacity");
});
/* END */


function waitFor({ selector, root = document, recursive = false }, fn) {
  let count = 0;
  if ( selector && root ) {
    new MutationObserver(function (_, observer) {
      const nodes = root.querySelectorAll(selector);
      if (nodes && nodes.length > count) {
        count = nodes.length;
        if (fn && !fn(nodes)) {
          observer.disconnect();
          console.log('disconnected');
        }
      }
    }).observe(root, { subtree: !!recursive, childList: true, });
  }
}

waitFor({
  selector: ".slick-track",
  root: document.querySelector(".slideshow"),
  recursive: true
}, function (nodes) {
  nodes[0].ariaLabel = 'carousel';
//   nodes[0].title = 'carousel';
});

waitFor({
  selector: ".headline",
  root: document.querySelector(".yotpo-reviews-carousel"),
  recursive: true
}, function (nodes) {
  nodes[0].ariaLevel = 1
});

// waitFor({
//   selector: "form.klaviyo-form button",
//   root: document.querySelector(".klaviyo-form-VwDAUZ"),
//   recursive: true
// }, function (nodes) {
//   nodes[0].className = '';
//   nodes[0].style = '';
//   nodes[0].className = 'btn-primary';
//   console.log(nodes)
// });


(function(){
  let secondaryBtn = document.querySelector('#section-id-template--14257587814482__165055952206fee94e .overlay-text__button-row a.btn-secondary');
  if ( secondaryBtn ) {
    if(window.innerWidth < 1024){
      secondaryBtn.classList.remove('btn-secondary');
      secondaryBtn.classList.add('btn-primary');
    }
  }
})();

// Reload Page when clicked on pagination
  $(window).on('load', function() {
    $('.pagination__number a, .pagination .next, .pagination .prev').click(function(){
      window.location.href = this.href;
    });
  })